import { baseURL } from '..';
import { IDocument } from '../../shared/iDocument';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';

const documentProvider = () => {
    const getDocumentPreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IDocument>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Document/GetPaginatedDocument', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const getAllDocumentAsync = async (): Promise<IResponse<IDocument[]>> => httpClient.getAsync(createRequest(baseURL, '/Document/GetAllDocument'), createHeaders());

    const insertDocumentAsync = async (payload: FormData): Promise<IResponse<IPaginatedResponse<IDocument>>> =>
        httpClient.postAsync(createRequest(baseURL, '/Document/InsertDocument', payload), createHeaders('multipart/form-data'));

    const deleteDocumentAsync = async (id: number): Promise<IResponse> => httpClient.deleteAsync(createRequest(baseURL, `/Document/DeleteDocument?id=${id}`), createHeaders());

    return { getDocumentPreviewsAsync, getAllDocumentAsync, deleteDocumentAsync, insertDocumentAsync };
};

export default documentProvider();
